var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesembarque1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 507.47 541.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#757575;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 61") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.42,172.68c3.67,1.51,7.68,1.95,11.32,3.66a41.45,41.45,0,0,1,23.11,47.33c-4.48,18.82-22.28,32.43-41.39,31.63a41.49,41.49,0,0,1-39.67-35.47c-3.07-20.2,10.11-40.32,29.89-45.65,1.32-.36,2.81-.27,3.78-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.73,327c-2-7.43-7.13-11.48-14.59-12.41C178.4,313,167,308,156.16,301.42c-14.53-8.79-27.39-19.76-39.94-31.09-16.45-14.86-37.9-17.95-55.8-3.68l-.07.05a24.24,24.24,0,0,0-8.74,15.36,194.72,194.72,0,0,0-1.15,44.87c1.51,17.42,3,34.09,4.39,50.76.63,7.56,1.24,15.14,6.43,21.25,1.52,1.78,1.42,3.06.35,5-11.19,20.19-22.25,40.45-33.37,60.67-8.75,15.94-17.79,31.71-26.19,47.83C-3,522.18,1.65,534.09,11.5,539c10.27,5.07,21.65,1,27.64-9.87C53.27,503.42,66.32,477.19,80,451.31c4.4-8.32,8.94-16.54,13.65-25.24.91,1.47,1.53,2.44,2.11,3.43,11.78,19.87,22.31,40.4,32.37,61.18,6.2,12.8,11.89,25.84,18,38.66a20,20,0,0,0,24.32,10.81c12.26-3.84,17.64-16.63,12.1-29-16.86-37.81-35-75-56.58-110.35-1.19-2-1-3.25.22-5a24.09,24.09,0,0,0,4.7-15.52c-.59-10-1.52-20.07-2.38-30.1-.64-7.51-1.34-15-2.16-22.51-.11-1.05-.8-2.28.09-2.93s2,.26,2.84.91c17.71,13.35,38.21,18.81,59.81,21.09a14.65,14.65,0,0,0,10.16-2.9A15.73,15.73,0,0,0,205.73,327Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 194.98,
    y: 160.51,
    width: 127.04,
    height: 127.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.11,
    y: 272.31,
    width: 102.79,
    height: 30.49,
    rx: 15.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.81,29.31c-2.65,3-6.05,5.12-8.57,8.25a41.46,41.46,0,0,0,0,52.67c12.28,15,34.25,19.38,51.06,10.28a41.49,41.49,0,0,0,20.11-49.27c-6.1-19.5-26.77-31.81-46.88-27.93-1.34.26-2.65,1-4.06.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.14,216.53a23.54,23.54,0,0,0,0-7.9,62.78,62.78,0,0,0-3.87-12.42c-6.06-15.6-12-31.23-18.32-47.54a194.87,194.87,0,0,0-20.7-39.83,24.19,24.19,0,0,0-14.59-10l-.09,0c-1.37-.31-2.73-.55-4.07-.72-20.44-2.73-36.71,9.19-44.47,28.5-6.31,15.68-13.06,31.18-22.26,45.45-6.85,10.64-14.91,20.16-25.65,27.19-6.3,4.12-9.17,10-7.67,17.56a15.72,15.72,0,0,0,13.1,12.24,14.65,14.65,0,0,0,10.4-1.85c18.41-11.52,34.45-25.41,44.51-45.17.49-1,1-2.29,2.16-2.08s1,1.61,1.36,2.6c2.55,7.1,5.21,14.15,7.93,21.18,3.62,9.39,7.19,18.81,11,28.1a23.77,23.77,0,0,0,9.54,11c.48.31,1,.6,1.49.88,1.91,1.05,2.61,2.13,2.4,4.42-3.86,41.26-3.88,82.61-2.46,124,.47,13.58,10.91,22.72,23.62,20.79a20,20,0,0,0,17.12-20.37c-.1-14.22-.71-28.44-.75-42.66-.07-23.08.39-46.16,2.27-69.18.09-1.15.22-2.29.39-4,6,4.3,11.84,8.4,17.56,12.51V221.35a3.66,3.66,0,0,1-.34-3.22C506.94,217.59,507.05,217.06,507.14,216.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 322.78,
    y: 143.65,
    width: 102.79,
    height: 30.49,
    rx: 15.24,
    transform: "translate(780.13 137.63) rotate(153.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 445.5,
    width: 61.64,
    height: 399.27
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesembarque1);
export default __webpack_public_path__ + "static/media/desembarque1.a9aa0630.svg";
export { ForwardRef as ReactComponent };